import React, { Component } from 'react';
import {
  Card,
  Row,
  Col,
  Table,
  Button,
  Alert as Alert2,
  CardHeader,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import { api, filterHelper, dateHelper, constant} from "../helpers";
import { TextFilter, FilterSet, UploadPanel, DateFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import 'react-datepicker/dist/react-datepicker.css';
import classnames from "classnames";

const UCToolTip = (props) => {
  return (
    <UncontrolledTooltip
      placement={props.placement}
      target={props.target}
      data-html="true"
    >
      {props.text}
    </UncontrolledTooltip>
  );
};

export default class UploadDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      importProcessing: false,
      uploadResults: null,
      searchDate: new Date(), 
      searchSku: '',
      searchMonthTotal: null,
      editShippingData: null,
      filters: [],
      pagedList: null,
      sortColumn: "Sku",
      sortAscending: true,
      editMode: true,
      showUploadPanel: false
    }
    this.onDismiss = this.onDismiss.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onSearchDateChange = this.onSearchDateChange.bind(this);
    this.generateTableHeader = this.generateTableHeader.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.countInputRef = [];
  }
  componentDidMount() {
    this.onChangeFilter({
      filterName: "dateOccurred",
      value: new Date(),
      filteredDisplay: this.props.uploadType === constant.uploadType.shipping
        ? `Shipping Date: ${dateHelper.getSelectedDate(new Date(), "MM/DD/YYYY")}`
        : `Production Date: ${dateHelper.getSelectedDate(new Date(), "MM/DD/YYYY")}`
    });
    this.setState({
      message: "Double Click on row item to edit",
      messageColor: "info",
      isMessageVisible: true
    })
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post(this.props.apiRoute, payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            searchMonthTotals: response.data.searchMonthTotal,
            filters: resolvedFilters,
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  onSearchDateChange(selectedDate) {
    this.setState({
      searchDate: selectedDate
    }, () => {
      this.onChangeFilter({
        filterName: "dateOccurred",
        value: selectedDate,
        filteredDisplay: `${this.props.uploadType} Date: ${dateHelper.getSelectedDate(selectedDate, "MM/DD/YYYY")}`
      });
    });
  }
  onFilterInputChange(e) {
    this.setState({
      searchSku: e.target.value
    }, () => {
      this.onChangeFilter({
        filterName: "Sku",
        value: e.target.value,
        filteredDisplay: "Sku"
      });
    });
  }
  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({
      filters: filters,
      searchDate: changedFilter.filterName === "dateOccurred"
        ? changedFilter.value
        : this.state.searchDate
    });
    this.refreshList(null, null, filters, 1);
  }

  onEdit(productId, countIndex) {
    let eList = this.state.pagedList.list.slice();
    const itemIndex = _.findIndex(eList, { productId: productId });
    eList[itemIndex].days[countIndex].editing = true;
    eList[itemIndex].days[countIndex].pristineCount = eList[itemIndex].days[countIndex].count;
    this.setState({
      pagedList: { ...this.state.pagedList, list: eList },
      editMode: true
    }, () => {
      this.countInputRef[countIndex].focus();
    });
  }

  onCancelEdit(countId) {
    let cList = this.state.pagedList.list.slice();
    const itemIndex = _.findIndex(cList, { id: countId });
    cList[itemIndex].editing = false;
    cList[itemIndex].count = cList[itemIndex].pristineCount;
    delete cList[itemIndex].pristineCount;

    this.setState({
      pagedList: { ...this.state.pagedList, list: cList },
      editMode: false
    })
  }

  onSave(productId, countIndex) {
    let cList = this.state.pagedList.list.slice();
    let item = _.find(cList, { productId: productId });
    const itemIndex = _.findIndex(cList, { productId: productId });
    let day = item.days[countIndex];

    if (day.id === 0) {
      cList[itemIndex].days[countIndex].editing = false;
      cList[itemIndex].days[countIndex].count = cList[itemIndex].days[countIndex].pristineCount;
      delete cList[itemIndex].days[countIndex].pristineCount;

      this.setState({
        pagedList: { ...this.state.pagedList, list: cList },
      }, () => {
          if (this.props.uploadType === constant.uploadType.shipping) {
            Alert.warning(`Code is required to save a new ${this.props.uploadType} count.`);
          } else {
            Alert.warning(`New ${this.props.uploadType} count cannot be saved without existing count data.`);
          }
      });
    } else {
      if (parseInt(day.count, 10) === day.pristineCount) {
        cList[itemIndex].days[countIndex].editing = false;
        delete cList[itemIndex].days[countIndex].pristineCount;
        this.setState({
          pagedList: { ...this.state.pagedList, list: cList },
        })
      } else {
        let payload = {
          Id: day.id,
          Count: parseInt(day.count, 10)
        }
        api.post(this.props.saveApiRoute, payload)
          .then(response => {
            if (response.data.success) {
              Alert.success(`${item.sku}'s ${this.props.uploadType} data has been updated.`)
              cList[itemIndex].days[countIndex].editing = false;
              cList[itemIndex].monthsTotal = _.sumBy(cList[itemIndex].days, s => {
                return parseInt(s.count, 10);
              });
              this.setState({
                pagedList: { ...this.state.pagedList, list: cList },
              })
            } else {
              Alert.error(`An error occurred. ${item.sku}'s ${this.props.uploadType} data cannot be updated at this time.`)
            }
          }).catch(error => Alert.error(`There was an error updating ${item.sku}'s ${this.props.uploadType} data.`));
      }
    }
  }

  onInputChange(e, productId, countIndex) {
    let cList = this.state.pagedList.list.slice();
    const itemIndex = _.findIndex(cList, { productId: productId });
    cList[itemIndex].days[countIndex][e.target.name] = e.target.value;

    this.setState({
      pagedList: { ...this.state.pagedList, list: cList }
    });
  }

  generateTableHeader(item) {
    const numOfHeaderColumn = item.days.length;

    let columns = [];
    for (var i = 1; i < (numOfHeaderColumn + 1); i++) {
      columns.push(<th className="upHeader" key={i}>{i}</th>)
    }
    columns.push(<th key={numOfHeaderColumn + 1}>Total</th>);
    columns.unshift(<th key={0}>Sku</th>);
    return columns;
  };


  render() {
    let productItem = this.state.pagedList ? this.state.pagedList.list[0] : null;
    return (
      <div>
        {this.state.showUploadPanel && (
          <UploadPanel
            uploadType={this.props.uploadType}
            onCancel={() => this.setState({ showUploadPanel: false })}
            onSuccess={this.onSearchDateChange}
          />
        )}
        <Card>
          <CardHeader className="pageTitle">
            <Row className="p-2 mb-2">
              <Col><h5>Prior Day {this.props.uploadType} Summary</h5></Col>
              {!this.state.showUploadPanel &&
                <Col>
                  <Button size="sm" className="uploadButton float-right" onClick={() => this.setState({ showUploadPanel: true })}>Upload</Button>
                </Col>
              }
            </Row>
          </CardHeader>
          <CardBody>
            {this.state.message ? (
              <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
            ) : null}

            <Row className="p-2 mt-2">
              <Col className="float-right">
                <h3 className="float-right">{constant.monthNames[this.state.searchDate.getMonth()]} </h3>
              </Col>
            </Row>

            <Row className="rowSpacing cursor">
              <Col>
                <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
                  <Col xs="3">
                    <DateFilter
                      filterName="dateOccurred"
                      displayName={`${this.props.uploadType} Date`}
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "dateOccurred",
                        this.state.filters
                      )}
                    />
                  </Col>
                  <Col xs="3">
                    <TextFilter
                      filterName="productName"
                      displayName="Product Name"
                      descriptionPrefix="contains"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "productName",
                        this.state.filters
                      )}
                    />
                  </Col>
                  <Col xs="3">
                    <TextFilter
                      filterName="sku"
                      displayName="Sku"
                      descriptionPrefix="contains"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "sku",
                        this.state.filters
                      )}
                    />
                  </Col>
                </FilterSet>
              </Col>
            </Row>

            {productItem ? (
              <Row className="p-2">
                <Col className="p-2">
                  <Table size="sm" responsive className="p-2">
                    <thead>
                      <tr>
                        {productItem ? this.generateTableHeader(productItem) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                        this.state.pagedList.list.map((item, pindex) => (
                          <tr key={item.productId}>
                            <td>
                              <span className="noWrap" id={`product-${item.productId}`}>{item.sku}</span>
                              <UCToolTip
                                key={`p-{item.productId}`}
                                placement="right"
                                target={`product-${item.productId}`}
                                text={[`${item.productName}`, <br key={`p-{item.productId}`} />, `Code: ${item.code}`]}
                              />
                            </td>
                            {item.days && item.days.length && (
                              item.days.map((d, index) => (
                                d.editing ? (
                                  <td key={`${d.index}-${d.sku}`} className={classnames({ "highlightRow": d.isFilterDate ? true : false }, "upCell")}>
                                    <input
                                      value={d.count}
                                      onChange={(e) => this.onInputChange(e, item.productId, index)}
                                      onBlur={() => this.onSave(item.productId, index)}
                                      type="number"
                                      name="count"
                                      id='count'
                                      ref={(ex) => this.countInputRef[index] = (ex)}
                                    />
                                  </td>
                                ) : (
                                    <td key={`dc-${index}${item.sku}`}
                                      className={classnames({ "highlightRow": d.isFilterDate ? true : false, "cursor": d.isFilterDate ? false : true }, "upCell")}
                                      title="Double click to edit"
                                      onDoubleClick={() => this.onEdit(item.productId, index)}>
                                      {d.count}
                                    </td>
                                  ))))}
                            <td>{item.monthsTotal}</td>
                          </tr>
                        ))) : null}
                    </tbody>
                  </Table>
                  <Pager {...this.state.pagedList} callBack={this.setPage} />

                </Col>
              </Row>
            ) : (
                <div className="detailText centerText"><span>No counts available for this month</span></div>
              )}
          </CardBody>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadDisplay.js